import {ManualOnlineComponent} from './../../business/manual-online/manual-online.component';
import {Component, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {UpdatePasswordComponent} from '@business/update-password/update-password.component';

import {AuthenticationService} from '@services/authentication.service';
import {LayoutService} from '@services/layout.service';
import {ConfigService} from '@services/webFeeder/config.service';
import {Constants} from '@utils/constants';
import {UpdateSignatureComponent} from '@business/update-signature/update-signature.component';
import {
  UpdatePasswordNegotiationComponent
} from '@business/update-password-negotiation/update-password-negotiation.component';
import {SupportChannelsComponent} from '@business/support-channels/support-channels.component';
import {WhitelabelEnum} from '@model/enum/whitelabel.enum';
import {WhitelabelBrokerEnum} from '@model/enum/whitelabel-broker.enum';
import {MatDialog} from '@angular/material/dialog';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {AuthServer} from "../../services/auth-server.service";
import {ALERT_TYPE} from "../../utils/constants";

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
})

export class UserSettingsComponent implements OnInit {

  accountLogged: string;
  darkThemeSelected = false;
  toggleInfo = 'desativado';
  dialog: MatDialog;
  downloadUrl = Constants.LINK_DOWNLOAD_FT_DESKTOP;
  imgUrl = Constants.IMG_NOTEBOOK_URL;
  isWSO2: boolean;
  userName: string;
  isAssessor: boolean;
  showHelp: boolean;
  isMarketDatePassword = false;
  isLoggedNegotiation = false;
  configWhiteLabel: any;
  showChangePassword: boolean;
  showNegotiation = false;
  showQuotation = false;
  showUrlStore: boolean;
  accountSelected: string = '';
  infoAlertType = ALERT_TYPE.info;
  plan: string;
  usernamePlatform: string;


  constructor(
    dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private authServer: AuthServer,
  ) {
    this.dialog = dialog;
    this.accountLogged = this.configService.getBrokerAccount();
    this.isWSO2 = this.configService.isLoginTypeWSO2();
    this.isAssessor = this.configService.isUserAssessorLogged();
    this.configWhiteLabel = this.configService.getConfigWhitelabel();
    if (this.configWhiteLabel.system.cod !== WhitelabelEnum.CEDRO && this.configWhiteLabel.system.cod !== WhitelabelEnum.FASTTRADE) {
      this.showHelp = true;
    }
    this.showUrlStore = this.configService.registerGoToIdentity() && this.configWhiteLabel.system.cod === WhitelabelEnum.CEDRO;
    const accountSelected = this.configService.getInfoUserLogged();
    if (this.configService.isUserAssessorLogged()) {
      this.userName = this.configService.getUserSystemLogged() ? this.configService.getUserSystemLogged().split(' ')[0].toUpperCase() : '';
    } else if (accountSelected && accountSelected.accountDesc) {
      this.userName = accountSelected.accountDesc;
    }
    if (this.configWhiteLabel.password.isActive) {
      this.showChangePassword = this.configWhiteLabel.password.isActive;
      this.showNegotiation = this.configWhiteLabel.password.showNegotiation;
      this.showQuotation = this.configWhiteLabel.password.showQuotation;
    }
    this.accountSelected = this.configService.getBrokerAccountSelected();
  }



  getInitialUsername(): string {
    const name = this.userName || this.usernamePlatform;
    if (name) {
      if (name.split(' ').length > 1) {
        return name.split(' ')[0].charAt(0) + name.split(' ')[1].charAt(0);
      }
      return name.split(' ')[0].charAt(0);
    }
    return '';
  }

  ngOnInit() {
    if (this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS) {
      this.isMarketDatePassword = true;
    }


    this.darkThemeSelected = this.configService.getFavoriteThemeUser();
    this.setThemeState()
    this.configService.changeThemeDarkLight$.subscribe(isDark => {
      this.darkThemeSelected = isDark == 1 ? true : false;
      if (this.darkThemeSelected) {
        this.toggleInfo = 'ativado';
      }
    });

    this.configService.authHbLogged$.subscribe(loggedNegotiation => {
      this.isLoggedNegotiation = loggedNegotiation;
      if (this.isLoggedNegotiation && this.configWhiteLabel.system.isMultiBroker) {
        this.showNegotiation = false;
        const multiBrokerSelected = this.configService.getConfigMultibroker();
        if (multiBrokerSelected && multiBrokerSelected.usersBrokerName !== WhitelabelBrokerEnum.CEDRO) {
          this.showNegotiation = this.configWhiteLabel.password.showNegotiation;
          this.showQuotation = false;
        }
      }
    });
    this.getContextInfoUser();
  }

  getContextInfoUser() {
    const userMarketData = this.configService.getUserMarketData();
    if (userMarketData && userMarketData.login && userMarketData.password) {
      this.authServer.iCedroServices.contextInfoUser(userMarketData.login, userMarketData.password)
        .subscribe((res: any) => {
          if (res && res.shadow) {
            this.plan = 'Plano atual: ' + res.shadow.fasttradeVersionDesc;
            this.usernamePlatform = res.shadow.shadowName;
          }
        });
    }
  }

  setThemeState(){
    if (this.darkThemeSelected) {
      this.toggleInfo = 'ativado';
      this.configService.setFavoriteThemeUser('true');
      this.configService._changeThemeDarkLight.next(1);
    } else {
      this.toggleInfo = 'desativado';
      this.configService.setFavoriteThemeUser('false');
      this.configService._changeThemeDarkLight.next(2);
    }
  }


  changeTheme() {
    this.layoutService.switchThemes();
    this.setThemeState()
  }

  openDownloadWindow() {
    window.location.href = this.downloadUrl;
  }

  openUpdatePasswordModal(type?) {
    if (type) {
      this.dialog.closeAll();
      this.dialog.open(UpdatePasswordComponent, {
        panelClass: 'mat-modal-fullheight',
        position: {left: '0'},
        width: '555px'
      });
    } else {
      this.dialog.closeAll();
      this.dialog.open(UpdatePasswordNegotiationComponent, {
        panelClass: 'mat-modal-fullheight',
        position: {left: '0'},
        width: '555px'
      });
    }
  }

  openManualOnline() {
    this.dialog.closeAll();
    this.dialog.open(ManualOnlineComponent, {
      position: {left: '15px', top: '64px'},
      height: 'calc(100% - 83px)',
      width: 'calc(100% - 30px)',
      maxWidth: 'unset',
      panelClass: 'panel-class-modal-news-component',
      disableClose: true
    });
  }

  openStore() {
    window.open(this.configService.getUserStore(), '_blank');
  }

  openSupportChannels() {
    this.dialog.closeAll();
    this.dialog.open(SupportChannelsComponent, {
      panelClass: 'panel-class-contact-info',
      disableClose: true
    });
  }

  openUpdateSignature() {
    this.dialog.closeAll();
    this.dialog.open(UpdateSignatureComponent, {
      panelClass: 'mat-modal-fullheight',
      position: {left: '0'},
      width: '555px'
    });
  }

  goTo(value) {
    window.location.href = value;
  }

  logout() {
    const hbLoginTypeEnable = this.configService.getLoginTypeEnabled();
    if (hbLoginTypeEnable === Constants.LOGIN_S && !this.configService.getBrokerAccount()) {
      this.dialog.closeAll();
      this.authenticationService.logout();
      this.configService.REDIRECT_LOGOUT();
    } else {
      this.authenticationService.brokerServiceLogout()
        .subscribe((data: any) => {
          if (this.configService.isLoginTypeWSO2()) {
            if (data) {
              this.dialog.closeAll();
              this.configService._authHbLoginType.next(3);
              this.configService.REDIRECT_LOGOUT();
              this.authenticationService.logout();
            } else {
              this.configService._authHbLogged.next(false);
            }
          } else {
            if (data && (data.isAuthenticated === 'N' || (data.error === false || data.error === 'false'))) {
              if (hbLoginTypeEnable === Constants.LOGIN_O || hbLoginTypeEnable === Constants.LOGIN_A ||
                (hbLoginTypeEnable === Constants.LOGIN_S && this.configService.getBrokerAccount())) {
                this.dialog.closeAll();
                this.configService.REDIRECT_LOGOUT();
                this.authenticationService.logout();
              }
              this.configService._authHbLoginType.next(3);
            } else {
              this.configService._authHbLogged.next(false);
              this.dialog.closeAll();
              this.configService.REDIRECT_LOGOUT();
              this.authenticationService.logout();
            }
          }
        }, error => {
          this.configService._authHbLogged.next(false);
          this.configService.REDIRECT_LOGOUT();
          this.authenticationService.logout();
        });
    }
  }


  openExternalLink() {
    window.open(this.configService.getUserStore(), '_blank');
  }

}
